import { Inject, Injectable } from '@angular/core';
import {
  ClubHubDataService,
} from '@msslib/services';
import {
  Observable,
} from 'rxjs';
import {
  AffordabilityAndUiRequest,
  AffordabilityPollResponse,
  BtlAffordabilityRequest,
} from 'apps/clubhub/src/app/ignite/models/affordability';
import {
  IgniteResponse,
} from 'apps/clubhub/src/app/ignite/models';
import {
  LendersAbilityResponse,
  LendingTypeCode,
  OutcomeDetails,
  OutcomeResponse,
} from 'apps/shared/src/models';
import { PropertyModelRequest } from 'apps/clubhub/src/app/ignite/models/property';

@Injectable({
  providedIn: 'root',
})
/* Get data only for BTL products and affordability */
export class IgniteBtlService {
  public constructor(
    @Inject(ClubHubDataService) private clubHubDataService: ClubHubDataService,
  ) { }

  public getLenders(requestModel: any): Observable<OutcomeDetails> {
    return this.clubHubDataService.post<OutcomeDetails>('Ignite/GetLenders', requestModel);
  }

  public getAffordabilityPoll(
    pollJobID: number,
    affordabilitySearchId: string,
  ): Observable<AffordabilityPollResponse> {
    return this.clubHubDataService.get<AffordabilityPollResponse>(
      `Affordability/PollBtl/${pollJobID}/${affordabilitySearchId}?productType=${LendingTypeCode.Btl}`,
    );
  }

  public getAffordability(model: AffordabilityAndUiRequest): Observable<AffordabilityPollResponse>;
  public getAffordability(model: AffordabilityAndUiRequest, lenderName?: string): Observable<IgniteResponse>;
  public getAffordability(
    model: AffordabilityAndUiRequest,
    lenderName?: string,
  ): Observable<IgniteResponse> | Observable<AffordabilityPollResponse> {
    if (lenderName) {
      return this.clubHubDataService.post<IgniteResponse>(`Affordability/btl/${lenderName}`, model);
    }

    return this.clubHubDataService.post<AffordabilityPollResponse>('Affordability/btl', model);
  }

  public getAvailableLendersResponse() {
    return this.clubHubDataService.get<LendersAbilityResponse>('lender/availableLenders?lendingTypeCode=BTL');
  }

  public getIntuitiveOutcomes(affordabilityModelRequest: BtlAffordabilityRequest): Observable<OutcomeResponse[]> {
    return this.clubHubDataService.post<OutcomeResponse[]>('Ignite/GetIntuitiveOutcomes', affordabilityModelRequest);
  }

  public getIntuitive(propertySearchRequestViewModel: PropertyModelRequest | null): Observable<OutcomeResponse[]> {
    return this.clubHubDataService
      .post<OutcomeResponse[]>('propertyCriteriaV2/Intuitive', propertySearchRequestViewModel);
  }
}
